import { useMemo } from 'react'

import { CheckOutlined } from '@ant-design/icons'

import { ProDropdown } from '@eastcoal/common/components/ProDropdown'
import { pick } from '@eastcoal/common/utils/object'

import { NeStyleIcon } from '@eastcoal/icon/NeStyleIcon'

import { DropdownButton } from '../../../DropdownButton'
import { useImageCardStore } from '../../Store/hooks/useStore'

const items = [
  {
    key: 'none',
    label: '无样式'
  },
  {
    key: 'border',
    label: '图片描边'
  },
  {
    key: 'shadow',
    label: '图片阴影'
  }
]

export const StyleDropdown = () => {
  const {
    bordered,
    shadowed,
    toggleBordered,
    toggleShadowed,
    getPopupContainer
  } = useImageCardStore(state =>
    pick(state, [
      'bordered',
      'toggleBordered',
      'shadowed',
      'toggleShadowed',
      'getPopupContainer'
    ])
  )

  const selectedKeys = useMemo(() => {
    const keys: string[] = []
    if (bordered) keys.push('border')
    if (shadowed) keys.push('shadow')
    if (!bordered && !shadowed) keys.push('none')
    return keys
  }, [bordered, shadowed])

  return (
    <ProDropdown
      arrow={false}
      getPopupContainer={getPopupContainer}
      placement='bottomLeft'
      selectedIcon={<CheckOutlined />}
      trigger={['click']}
      menu={{
        items,
        selectedKeys,
        onClick({ key }) {
          if (key === 'none') {
            toggleBordered(false)
            toggleShadowed(false)
          } else if (key === 'border') {
            toggleBordered(true)
            toggleShadowed(false)
          } else if (key === 'shadow') {
            toggleBordered(false)
            toggleShadowed(true)
          }
        }
      }}
    >
      <DropdownButton icon={<NeStyleIcon />} tooltip='图片样式'>
        样式
      </DropdownButton>
    </ProDropdown>
  )
}
